import { IEthUserAddress } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { web3Api } from 'store/queries';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchUserETHAddresses },
  useFetchUserETHAddressesQuery,
  useLazyFetchUserETHAddressesQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchUserETHAddresses: build.query<IEthUserAddress[], void>({
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async () => {
          const api = MultiService.getService().getAccountingGateway();

          const { addresses } = await api.getETHAddresses();

          return { data: addresses };
        },
      }),
    }),
  }),
  overrideExisting: true,
});

const fetchUserETHAddressesFallback: IEthUserAddress[] = [];

export const {
  selectDataWithFallbackCachedByParams: selectUserETHAddresses,
  selectLoadingCachedByParams: selectUserETHAddressesLoading,
  selectStateCachedByParams: selectUserETHAddressesState,
} = createQuerySelectors({
  endpoint: fetchUserETHAddresses,
  fallback: fetchUserETHAddressesFallback,
});
